import { render, staticRenderFns } from "./ReferencesForm.vue?vue&type=template&id=9f33042e&"
import script from "./ReferencesForm.vue?vue&type=script&lang=js&"
export * from "./ReferencesForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferencesForm.vue"
export default component.exports